import { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

const ClientProvider = ({ children }: { children: ReactNode }) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        getNextPageParam: (lastPage: any) => lastPage.cursor ?? undefined,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

export default ClientProvider;
